const state = {
  currentLanguage: null,
  currentTheme: null
}

const actions = {
  setUserLanguage({ commit }, payload) {
    commit('set_user_language', payload)
  },
  setUserTheme({ commit }, payload) {
    commit('set_user_theme', payload)
  }
}

const mutations = {
  set_user_language(state, payload) {
    state.currentLanguage = payload
  },
  set_user_theme(state, payload) {
    state.currentTheme = payload
  }
}

const getters = {
  currentLanguage: state => state.currentLanguage,
  currentTheme: state => state.currentTheme
}

export default {
  state,
  actions,
  mutations,
  getters
}
